import React from "react";

const Title = ({ value }) => {
	return (
		<h5 className="mt-2">
			{value}
		</h5>
	);
};

export default Title;